import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class StockistsList {
    constructor(container) {
        this.container = container;
        this.entries = container.querySelectorAll('.stockists-list__entry');

        this.init();
    }

    init = () => {
        if (!this.entries.length) return;

        gsap.fromTo(
            this.entries,
            { opacity: 0, y: 40 },
            {
                opacity: 1,
                y: 0,
                duration: 0.7,
                ease: 'power2.out',
                stagger: { each: 0.08 },
                scrollTrigger: {
                    trigger: this.container,
                    start: 'top 85%',
                },
            }
        );
    };
}
